'use client';

import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/Button';
import { Link } from '@/i18n/routing';
import styles from './AuditFinalCTA.module.css';

export function AuditFinalCTA() {
  const t = useTranslations('audit.finalCTA');

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <section className={styles.section}>
      <div className={styles.container}>
        {/* Heading with gradient text */}
        <h2 className={styles.title}>{t('title')}</h2>

        {/* Subtitle */}
        <p className={styles.subtitle}>{t('subtitle')}</p>

        {/* Stats Bar */}
        <div className={styles.statsBar}>
          <div className={styles.stat}>
            <span className={styles.statValue}>167</span>
            <span className={styles.statLabel}>{t('stats.principles')}</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statValue}>12</span>
            <span className={styles.statLabel}>{t('stats.citations')}</span>
          </div>
          <div className={styles.statDivider} />
          <div className={styles.stat}>
            <span className={styles.statValue}>&lt;30s</span>
            <span className={styles.statLabel}>{t('stats.speed')}</span>
          </div>
        </div>

        {/* CTA Buttons */}
        <div className={styles.ctaButtons}>
          <Button variant="primary" size="lg" onClick={scrollToTop}>
            {t('ctaPrimary')}
          </Button>
          <Link href="/demo-report">
            <Button variant="secondary" size="lg">
              {t('ctaSecondary')}
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
